import React from "react";
import {
    useGetChildRequestQuery,
    useReviewRequestMutation,
} from "../../../../../store/requestManagement/requestSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PAGE_NAME, ROUTE } from "../../../../../constants/constants";
import { Comments } from "../../../../organisms/requestManagement/comments";
import { Skeleton } from "../../../../atoms/skeleton";
import { Dropdown } from "../../../../atoms/dropdown";
import { Dialog } from "../../../../atoms/dialog";
import { toast } from "react-toastify";

const ChildRequestDetails = () => {
    const pageClassName = "p-childRequestDetails";

    const { id } = useParams<{ id: string }>();
    const location = useLocation();
    const pathSegments = location.pathname.split("/");
    const url = pathSegments[1];
    const navigate = useNavigate();

    const { data, isLoading, isSuccess } = useGetChildRequestQuery(id as string);
    const [reviewAPI] = useReviewRequestMutation();

    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const [reviewData, setReviewData] = React.useState({
        status: "",
        id: undefined as string | undefined,
    });

    const [comments, setComments] = React.useState([]);

    React.useEffect(() => {
        if (data?.result?.comments) {
            setComments(data?.result?.comments);
        }
    }, [data]);

    const closeDialogHandler = () => {
        setIsDialogOpen(!isDialogOpen);
        setReviewData({
            status: "",
            id: id,
        });
    };

    const reviewHandler = async () => {
        setIsDialogOpen(!isDialogOpen);
        const fromData = new FormData();

        fromData.append("status", reviewData.status);
        fromData.append("id", reviewData.id as string);

        let response = (await reviewAPI(fromData)) as any;

        if (response?.data?.success) {
            toast.success(response?.data?.message);
        } else {
            toast.error(response?.error?.data?.message);
        }
    };

    return (
        <div className={pageClassName}>
            <div className={`${pageClassName}__breadcrumb`}>
                <button
                    onClick={() => navigate("/")}
                    className={`${pageClassName}__breadcrumb__dashboard`}
                >
                    Dashboard
                </button>
                <span>≫</span>
                <button
                    onClick={() =>
                        navigate(
                            url === "request-details"
                                ? ROUTE.ALL_REQUEST_LIST
                                : ROUTE.REQUEST_HISTORY
                        )
                    }
                    className={`${pageClassName}__breadcrumb__dashboard`}
                >
                    {url === "request-details" ? "All Request List" : "Request History"}
                </button>
                <span>≫</span>
                <span className={`${pageClassName}__breadcrumb__comment`}>
                    Comments
                </span>
            </div>
            <p className={`${pageClassName}__title`}>{PAGE_NAME.COMMENTS}</p>
            <div className={`${pageClassName}__container`}>
                {isSuccess && !data?.result?.isReviewed && (
                    <div className={`${pageClassName}__container__status`}>
                        <Dropdown
                            options={[
                                { label: "Approved", value: "Approved" },
                                { label: "Rejected", value: "Rejected" },
                            ]}
                            selected={{ label: "Review", value: "" }}
                            placeholder="Review"
                            onClickChange={(e) => {
                                setIsDialogOpen(!isDialogOpen);
                                setReviewData({
                                    ...reviewData,
                                    status: e.value as string,
                                    id: data?.result?.id,
                                });
                            }}
                            isBordered
                            isIcon
                        />
                    </div>
                )}
                <div
                    className={`${pageClassName}__container__userRequest__content__container`}
                >
                    <div className={`${pageClassName}__container__userRequest__item`}>
                        <p
                            className={`${pageClassName}__container__userRequest__item__title`}
                        >
                            Request ID
                        </p>
                        <p
                            className={`${pageClassName}__container__userRequest__item__value`}
                        >
                            {data?.result?.id}
                        </p>
                    </div>

                    <div className={`${pageClassName}__container__userRequest__item`}>
                        <p
                            className={`${pageClassName}__container__userRequest__item__title`}
                        >
                            Parent Request ID
                        </p>
                        <button
                            className={`${pageClassName}__container__userRequest__item__parentID`}
                            onClick={() =>
                                navigate(
                                    ROUTE.REQUEST_HISTORY + "/" + data?.result?.request?.id
                                )
                            }
                        >
                            {data?.result?.request?.id}
                        </button>
                    </div>

                    {data?.result?.firstName && data?.result?.lastName && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                User Name
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.firstName} {data?.result?.lastName}
                            </p>
                        </div>
                    )}

                    {data?.result?.firstName && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                First Name
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.firstName}
                            </p>
                        </div>
                    )}

                    {data?.result?.lastName && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Last Name
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.lastName}
                            </p>
                        </div>
                    )}

                    {data?.result?.designation && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Designation
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.designation}
                            </p>
                        </div>
                    )}


                    {data?.result?.address && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Location
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.address}
                            </p>
                        </div>
                    )}

                    {data?.result?.organization && (
                        <div
                            className={`${pageClassName}__container__userRequest__item`}
                        >
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Organization
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.organization?.name}
                            </p>
                        </div>
                    )}

                    {data?.result?.department && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Department
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.department}
                            </p>
                        </div>
                    )}

                    {data?.result?.section && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Section
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.section}
                            </p>
                        </div>
                    )}

                    {data?.result?.projects?.length > 0 && (
                        <div
                            className={`${pageClassName}__container__userRequest__item`}
                        >
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Projects
                            </p>
                            <div
                                className={`${pageClassName}__container__userRequest__item__list`}
                            >
                                {data?.result?.projects.map((project: any, index: number) => (
                                    <li key={index}>{project}</li>
                                ))}
                            </div>
                        </div>
                    )}

                    {data?.result?.manager && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                PIC/Manager
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.manager?.middleName
                                    ? `${data?.result?.manager?.firstName} ${data?.result?.manager?.middleName} ${data?.result?.manager?.lastName} (${data?.result?.manager?.email})`
                                    : `${data?.result?.manager?.firstName} ${data?.result?.manager?.lastName} (${data?.result?.manager?.email})`}
                            </p>
                        </div>
                    )}

                    {data?.result?.email && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Email
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.email}
                            </p>
                        </div>
                    )}

                    <div className={`${pageClassName}__container__userRequest__item`}>
                        <p
                            className={`${pageClassName}__container__userRequest__item__title`}
                        >
                            SaaS Tool
                        </p>
                        <p
                            className={`${pageClassName}__container__userRequest__item__value`}
                        >
                            {isLoading ? <Skeleton height="small" /> : data?.result?.saasTool}
                        </p>
                    </div>

                    {data?.result?.type && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Type
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.type}
                            </p>
                        </div>
                    )}

                    {data?.result?.type && data?.result?.name && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                {data?.result?.type} Name
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.name}
                            </p>
                        </div>
                    )}

                    {data?.result?.type && data?.result?.newName && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                {data?.result?.type} New Name
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.newName}
                            </p>
                        </div>
                    )}

                    {data?.result?.role && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Role
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.role}
                            </p>
                        </div>
                    )}

                    {data?.result?.templateType && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Template Type
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.templateType}
                            </p>
                        </div>
                    )}
                    {data?.result?.approvers?.length > 0 && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Approvers
                            </p>
                            <div
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.approvers.map((approver: any, index: number) => (
                                    <p key={index}>
                                        {approver?.middleName
                                            ? `${approver?.firstName} ${approver?.middleName} ${approver?.lastName}`
                                            : `${approver?.firstName} ${approver?.lastName}`}
                                    </p>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className={`${pageClassName}__container__userRequest__item`}>
                        <p
                            className={`${pageClassName}__container__userRequest__item__title`}
                        >
                            Status
                        </p>
                        <p
                            className={`${pageClassName}__container__userRequest__item__status`}
                        >
                            {isLoading ? "-" : data?.result?.status}
                        </p>
                    </div>

                    {data?.result?.reviewedBy && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Reviewed By
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.reviewedBy?.middleName
                                    ? `${data?.result?.reviewedBy?.firstName} ${data?.result?.reviewedBy?.middleName} ${data?.result?.reviewedBy?.lastName}`
                                    : `${data?.result?.reviewedBy?.firstName} ${data?.result?.reviewedBy?.lastName}`}
                            </p>
                        </div>
                    )}

                    {data?.result?.issueSummary && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Issue Summary
                            </p>
                            <p
                                className={`${pageClassName}__container__userRequest__item__value`}
                            >
                                {data?.result?.issueSummary}
                            </p>
                        </div>
                    )}

                    {data?.result?.instruction && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Issue Description
                            </p>
                            <p
                                style={{
                                    whiteSpace: 'pre-line',
                                    overflowWrap: 'break-word',
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-all'
                                }}
                                className={`${pageClassName}__container__userRequest__item__value`}
                                dangerouslySetInnerHTML={{ __html: data?.result?.instruction }}
                            />
                        </div>
                    )}

                    {data?.result?.files.length > 0 && (
                        <div className={`${pageClassName}__container__userRequest__item`}>
                            <p
                                className={`${pageClassName}__container__userRequest__item__title`}
                            >
                                Attachments
                            </p>
                            <div
                                className={`${pageClassName}__container__userRequest__item__files`}
                            >
                                {data?.result?.files.map((file: any, index: number) => (
                                    <a
                                        href={file.basePath + "/" + file?.filePath}
                                        target="_blank"
                                        rel="noreferrer"
                                        key={index}
                                        className={`${pageClassName}__container__userRequest__item__files__file`}
                                    >
                                        {file?.fileName}
                                    </a>
                                ))}
                            </div>
                        </div>
                    )}

                    <Dialog
                        header="Review Request"
                        body={
                            <div className={`${pageClassName}__dialog`}>
                                <p className={`${pageClassName}__dialog__text`}>
                                    Are you sure you want to {reviewData.status.toLowerCase()}{" "}
                                    this request?
                                </p>
                                <p className={`${pageClassName}__dialog__text`}>
                                    This action cannot be undone.
                                </p>
                                {/* <Textarea
                            className={`${pageClassName}__dialog__textarea`}
                            placeholder="Add a comment"
                            onChange={(e) => {
                                setReviewData({ ...reviewData, comment: e.target.value });
                            }}
                        /> */}
                            </div>
                        }
                        isOpen={isDialogOpen}
                        onClose={closeDialogHandler}
                        successFn={reviewHandler}
                        btn={reviewData.status}
                        icon={reviewData.status === "Approved" ? "approved" : "rejected"}
                        color={reviewData.status === "Approved" ? "green" : undefined}
                    />

                    <Comments
                        requestId={id as string}
                        comments={comments}
                        setComments={setComments}
                    />
                </div>
            </div>
        </div>
    );
};

export default ChildRequestDetails;
